import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import {BeanGameWrapper, EmojiBar, EmojiButtonWrapper} from './BeanGameComponent.styles';
import Button from "../../shared/Button/Button.jsx";
import RichText from "../../shared/JssOverridesRichText";


const BeanGameComponent = (
    {
        title,
        className,
        field,
        tag,
        editable,
        sitecoreContext,
        id,
    }
) => {
    const [activeEmoji, setActiveEmoji] = useState('🤌');
    const [recipeData, setRecipeData] = useState({
        link: "https://www.bushbeans.com/en_US/bean-recipes/barbecue-chicken-nachos",
        img: "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Barbecue-Chicken-Nachos-800x500.jpg",
        alt: "Bush’s® Barbecue Chicken Nachos",
        isVisible: true
    });
    const buttonRef = useRef(null);
    const emojiBarRef = useRef(null);
    const handleEmojiClick = (emojiData) => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 650) {
            emojiBarRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        setActiveEmoji(emojiData.emoji);
        setRecipeData({
            link: emojiData.dataLink,
            img: emojiData.dataImg,
            alt: emojiData.dataAlt,
            isVisible: true
        });

        const emojiElements = document.querySelectorAll('.emoji');
        emojiElements.forEach((emojiElement) => {
            if (emojiElement.getAttribute('data-emoji') === emojiData.emoji) {
                emojiElement.classList.add('active');
            } else {
                emojiElement.classList.remove('active');
            }
        });

        const recipeImageUpdate = document.getElementById('recipeImageUpdate');
        if (recipeImageUpdate) {
            recipeImageUpdate.classList.add('animate');
            setTimeout(() => {
                if (recipeImageUpdate) {
                    recipeImageUpdate.classList.remove('animate');
                }
            }, 300);
        }

        const recipeButton = document.getElementById('recipeButtonUpdate');
        if (recipeButton) {
            recipeButton.classList.add('animate');
            setTimeout(() => {
                if (recipeButton) {
                    recipeButton.classList.remove('animate');
                }
            }, 300);
        }

        const emojiSpan = document.querySelector('.emoji-transition');
        if (emojiSpan) {
            emojiSpan.classList.add('animate');
            setTimeout(() => {
                if (emojiSpan) {
                    emojiSpan.classList.remove('animate');
                }
            }, 300);
        }
    };


    const clearAll = () => {
        setActiveEmoji(null);
        setRecipeData({
            link: '',
            img: '',
            alt: '',
            isVisible: false
        });
    };


    return (
        <BeanGameWrapper className="emoji-bean-recipe">
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                <link href="https://fonts.googleapis.com/css2?family=Noto+Color+Emoji&display=swap" rel="stylesheet" />
            </Helmet>
            <RichText className="section-titles" field={field} tag={tag} editable={editable}/>
            <EmojiBar ref={emojiBarRef}>
                <div className="item beans">
                    <span className="emoji-font">🫘</span>
                </div>
                <div className="item plus">
                    <span role="img" aria-label="beans" className="chunk">+</span>
                </div>
                <div className="item emoji">
                    <span className="emoji-transition">{activeEmoji}</span>
                </div>
                <div className="item equals">
                    <span className="chunk">=</span>
                </div>
                <div className="recipe-square">
                    <div className="item recipe">
                        <img id="recipeImageUpdate" src={recipeData.img} alt="{recipeData.alt}"
                             style={{display: recipeData.isVisible ? 'block' : 'none'}}/>
                    </div>
                    <Button
                        ref={buttonRef}
                        id="recipeButtonUpdate"
                        text="Go to Recipe"
                        href={recipeData.link}
                        variant="yellow"
                        style={{display: recipeData.isVisible ? 'flex' : 'none'}}
                    />
                </div>
            </EmojiBar>
          <EmojiButtonWrapper className="emoji-selector">
            <div className="emoji-container">
              <div
                className="emoji active"
                role="img"
                data-emoji="🤌"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🤌",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/barbecue-chicken-nachos",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Barbecue-Chicken-Nachos-800x500.jpg",
                    dataAlt: "Bush’s® Barbecue Chicken Nachos",
                  })
                }
              >
                🤌
              </div>

              <div
                className="emoji"
                data-emoji="🤠"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🤠",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/baked-beans-burnt-ends-bacon",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Bushs-burnt-ends-bacon-recipe-ingredients-800x500.jpg",
                    dataAlt: "Baked Beans With Burnt Ends & Bacon",
                  })
                }
              >
                🤠
              </div>

              <div
                className="emoji"
                data-emoji="🍳"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🍳",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/skillet-bean-breakfast",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Smoky-Skillet-Bean-Breakfast-800x500.jpg",
                    dataAlt: "Single Skillet Smoky Bean Breakfast",
                  })
                }
              >
                🍳
              </div>

              <div
                className="emoji"
                data-emoji="🥪"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🥪",
                    dataLink:
                      "http://bushbeans.com/en_US/bean-recipes/bbq-beef-brisket-sandwich",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-02-99_1920x1280/17_BBQbeefbrisket_1920x1280.jpg",
                    dataAlt: "BBQ Beef Brisket Sandwich",
                  })
                }
              >
                🥪
              </div>

              <div
                className="emoji"
                data-emoji="🌱"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🌱",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/grilled-chile-rellenos-i",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-100-173_1920x1280/127_GrilledChiliRellenos_v1_LB_1920x1280.jpg",
                    dataAlt: "Grilled Chile Rellenos",
                  })
                }
              >
                🌱
              </div>

              <div
                className="emoji"
                data-emoji="🏈"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🏈",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/memphis-dry-rubbed-wings",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-100-173_1920x1280/131_MemphisDryRubbedWings_v1_LB_1920x1280.jpg",
                    dataAlt: "Memphis Dry-Rubbed Wings",
                  })
                }
              >
                🏈
              </div>

              <div
                className="emoji"
                data-emoji="🏄‍♂️"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🏄‍♂️",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/hawaiian-style-baked-beans",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/193_HawaiianStyleKabobs_plate_1920x1280.jpg",
                    dataAlt: "Hawaiian-Style Baked Beans",
                  })
                }
              >
                🏄‍♂️
              </div>

              <div
                className="emoji"
                data-emoji="🍁"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🍁",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/grilled-gameday-buffalo-wings",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-100-173_1920x1280/109_grilled-gameday-buffalo-wings_1920x1280_02.jpg",
                    dataAlt: "Grilled Gameday Buffalo Wings",
                  })
                }
              >
                🍁
              </div>

              <div
                className="emoji"
                data-emoji="🥤"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🥤",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/cola-baked-beans",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/213_Cola_Beans_ORL_1920x1280.jpg",
                    dataAlt: "Cola Baked Beans",
                  })
                }
              >
                🥤
              </div>

              <div
                className="emoji"
                data-emoji="🐓"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🐓",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/zero-sugar-added-baked-beans-with-chicken-apple-sausage-and-peppers",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/225_Bushs_ZeroSugarAdd_ChAppSausage_CAN_1920x1080.jpg",
                    dataAlt:
                      "Baked Beans with Chicken Apple Sausage and Peppers",
                  })
                }
              >
                🐓
              </div>

              <div
                className="emoji"
                data-emoji="⚾"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "⚾",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/zero-sugar-added-bbq-baked-beans",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/227_Bushs_ZeroSugarAdd_BBQbaked_CAN_1920x1080.jpg",
                    dataAlt: "Bush's® BBQ Baked Beans",
                  })
                }
              >
                ⚾
              </div>

              <div
                className="emoji"
                data-emoji="🐝"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🐝",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/sweet-heat-peppers-and-onions",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/212_Sweet_Heat_Peppers_Onions_SWH_1920x1280_LB.jpg",
                    dataAlt: "Sweet Heat Peppers and Onions",
                  })
                }
              >
                🐝
              </div>

              <div
                className="emoji"
                data-emoji="🫨"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🫨",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/shishito-slaw-dogs",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-100-173_1920x1280/172_20CL_BUB_3C_AF42515_UL_1920x1280.jpg",
                    dataAlt: "Shishito Slaw Dawg",
                  })
                }
              >
                🫨
              </div>

              <div
                className="emoji"
                data-emoji="👀"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "👀",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/chuckwagon-rollups",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/chuckwagon-rollups-800x500.jpg",
                    dataAlt: "Chuckwagon Rollups",
                  })
                }
              >
                👀
              </div>

              <div
                className="emoji"
                data-emoji="🥞"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🥞",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/spicy-baked-beans-and-eggs-toast",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-02-99_1920x1280/64_20CL_BUB_3C_AF42509_UL_1920x1280_02.jpg",
                    dataAlt: "Spicy Baked Beans & Eggs On Toast",
                  })
                }
              >
                🥞
              </div>

              <div
                className="emoji"
                data-emoji="⌚️"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "⌚️",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/hamburger-baked-beans",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/194_GrilledBrats_plate_1920x1280.jpg",
                    dataAlt: "Hamburger Baked Beans",
                  })
                }
              >
                ⌚️
              </div>

              <div
                className="emoji"
                data-emoji="🍗"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🍗",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/barbecue-chicken-rice-bowls",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Barbecue-Chicken-Bowls-800x500.jpg",
                    dataAlt: "Bush’s® Barbecue Chicken Rice Bowls",
                  })
                }
              >
                🍗
              </div>

              <div
                className="emoji"
                data-emoji="🎉"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🎉",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/sweet-heat-fajita-dogs",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-176-250_1920x996/189_SweetHeat_Fajita_HotDogs_1920x996.jpg",
                    dataAlt: "Sweet Heat Served with Fajita Dogs",
                  })
                }
              >
                🎉
              </div>

              <div
                className="emoji"
                data-emoji="🥵"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🥵",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/sweet-spicy-baked-beans-chicken",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Hawaiian-Baked-Beans-Chicken-800x500.jpg",
                    dataAlt:
                      "Bush’s® Sweet & Spicy Baked Beans with Chicken",
                  })
                }
              >
                🥵
              </div>

              <div
                className="emoji"
                data-emoji="🥶"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🥶",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/grilled-corn-bean-salsa",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-02-99_1920x1280/18_GrilledCornSalsa_CHIPS_1920x1280.jpg",
                    dataAlt: "Grilled Corn Bean Salsa",
                  })
                }
              >
                🥶
              </div>

              <div
                className="emoji"
                data-emoji="🌮"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🌮",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/layered-barbecue-bean-dip",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-02-99_1920x1280/15_Layered_BBQ_BeanDip_1920x1280.jpg",
                    dataAlt: "Layered Barbecue Bean Dip",
                  })
                }
              >
                🌮
              </div>

              <div
                className="emoji"
                data-emoji="🌯"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🌯",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/breakfast-egg-and-bean-burritos",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-100-173_1920x1280/133_20CL_BUB_3C_AF42526_UL_1920x1280.jpg",
                    dataAlt: "Breakfast Egg and Bean Burritos",
                  })
                }
              >
                🌯
              </div>

              <div
                className="emoji"
                data-emoji="🥗"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🥗",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/zero-sugar-added-baked-beans-with-ground-turkey",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/226_Bushs_ZeroSugarAdd_GrTurkeyBeans_CAN_1920x1080.jpg",
                    dataAlt: "Bush's® Baked Beans with Ground Turkey",
                  })
                }
              >
                🥗
              </div>

              <div
                className="emoji"
                data-emoji="🎃"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🎃",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/loaded-baked-potato",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-02-99_1920x1280/55_20CL_BUB_3C_AF42529_UL_1920x1280.jpg",
                    dataAlt: "Loaded Baked Potato",
                  })
                }
              >
                🎃
              </div>

              <div
                className="emoji"
                data-emoji="✈️"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "✈️",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/sweet-heat-baked-beans-sausage",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/200_SweetHeat_SausagePeppers_1920x1280.jpg",
                    dataAlt:
                      "Sweet Heat Baked Beans with Sausage and Peppers",
                  })
                }
              >
                ✈️
              </div>

              <div
                className="emoji"
                data-emoji="🤏"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🤏",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/bacon-guacamole-beef-sliders",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-100-173_1920x1280/173_20CL_BUB_3C_AF42528_UL_1920x1280.jpg",
                    dataAlt: "Bacon Guacamole Beef Sliders",
                  })
                }
              >
                🤏
              </div>

              <div
                className="emoji"
                data-emoji="🛶"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🛶",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/sweet-heat-grilled-burgers",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Details-176-250_1920x1280/190_SweetHeat_Grilled_Burgers_1920x1280.jpg",
                    dataAlt: "Sweet Heat with Grilled Burgers",
                  })
                }
              >
                🛶
              </div>

              <div
                className="emoji"
                data-emoji="💅"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "💅",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/grandmas-favorite-bushs-baked-beans",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Doctored-Baked-Beans-800x500.jpg",
                    dataAlt: "Grandma's Favorite Bush’s® Baked Beans",
                  })
                }
              >
                💅
              </div>

              <div
                className="emoji"
                data-emoji="🫘"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🫘",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/baked-beans-with-brisket",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Images/Baked-Beans-Brisket-800x500.jpg",
                    dataAlt: "Bush's® Original Baked Beans with Brisket",
                  })
                }
              >
                🫘
              </div>

              <div
                className="emoji"
                data-emoji="🐭"
                role="img"
                onClick={() =>
                  handleEmojiClick({
                    emoji: "🐭",
                    dataLink:
                      "https://www.bushbeans.com/en_US/bean-recipes/baked-bean-bacon-mac-cheese",
                    dataImg:
                      "https://www.bushbeans.com/-/jssmedia/BushsBeans/Recipe_Detail-02-99_1920x1280/47_baked-bean-bacon-mac-cheese_1920x1280.jpg",
                    dataAlt: "Baked Beans & Bacon Mac & Cheese",
                  })
                }
              >
                🐭
              </div>
            </div>
                <button style={{display: 'none'}} className="clear-btn" onClick={clearAll}>Clear all</button>
            </EmojiButtonWrapper>
        </BeanGameWrapper>
    );
};

export default BeanGameComponent;